export const ProjectStatusTypes = {
  open: 1,
  canceled: 3,
  finished: 4,
	draft: 5,
};